﻿(function () {
    "use strict";

    angular
        .module("app")
        .component("fabButtonAdd", {
            bindings: {
                href: "@",
                target: "@?",
                icon: "@"
            },
            templateUrl: ['version', function (version) {
                return `/js/components/fabButtonAdd/fab-button-add.html?v=${version}`
            }],
            transclude: true
        });
})();